// extracted by mini-css-extract-plugin
export default {"require":"Element_require__BmBVg","formControl":"Element_formControl__VSV7N"};